<template>
  <svg class="SideBurgerIcon-image" viewBox="0 0 50 32">
    <path d="M49,4H19c-0.6,0-1-0.4-1-1s0.4-1,1-1h30c0.6,0,1,0.4,1,1S49.6,4,49,4z"></path>
    <path d="M49,16H19c-0.6,0-1-0.4-1-1s0.4-1,1-1h30c0.6,0,1,0.4,1,1S49.6,16,49,16z"></path>
    <path d="M49,28H19c-0.6,0-1-0.4-1-1s0.4-1,1-1h30c0.6,0,1,0.4,1,1S49.6,28,49,28z"></path>
    <template v-if="showArrow">
      <path
        d="M8.1,22.8c-0.3,0-0.5-0.1-0.7-0.3L0.7,15l6.7-7.8c0.4-0.4,1-0.5,1.4-0.1c0.4,0.4,0.5,1,0.1,1.4L3.3,15l5.5,6.2   c0.4,0.4,0.3,1-0.1,1.4C8.6,22.7,8.4,22.8,8.1,22.8z">
      </path>
    </template>
  </svg>
</template>

<script>
export default {
  props: {
    showArrow: Boolean
  }
}
</script>

<style lang="scss" scoped>
svg {
  cursor: pointer;
  fill: #9ca6af;
  &:hover, &:focus {
    fill: #cacaca;
  }
}
</style>
